import { render, staticRenderFns } from "./ELButton.vue?vue&type=template&id=765c4492&scoped=true"
import script from "./ELButton.vue?vue&type=script&lang=js"
export * from "./ELButton.vue?vue&type=script&lang=js"
import style0 from "./ELButton.vue?vue&type=style&index=0&id=765c4492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c4492",
  null
  
)

export default component.exports